import React, { useState, useEffect, useRef } from 'react'
import { COUNTRY_CODES, DEFAULT_COUNTRY_CODE } from '@common/countryCodes'
import './CountryCodeSelector.css'

const CountryCodeSelector = ({ value, onChange, error, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false)
    const selectorRef = useRef(null)
    const selectedCountry = COUNTRY_CODES.find(country => country.code === value) || COUNTRY_CODES[0]

    const handleCountrySelect = country => {
        onChange(country.code)
        setIsOpen(false)
    }

    // Handle clicking outside to close dropdown
    useEffect(() => {
        const handleClickOutside = event => {
            if (selectorRef.current && !selectorRef.current.contains(event.target)) {
                setIsOpen(false)
            }
        }

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [isOpen])

    return (
        <div className="country-code-selector" ref={selectorRef}>
            <div
                className={`country-code-dropdown ${error ? 'is-invalid' : ''} ${disabled ? 'disabled' : ''}`}
                onClick={() => !disabled && setIsOpen(!isOpen)}
            >
                <div className="country-code-display">
                    <span className="country-flag">{selectedCountry.flag}</span>
                    <span className="country-code">{selectedCountry.code}</span>
                    <i className={`bx bx-chevron-${isOpen ? 'up' : 'down'}`}></i>
                </div>
            </div>

            {isOpen && (
                <div className="country-code-options">
                    {COUNTRY_CODES.map(country => (
                        <div
                            key={country.code}
                            className={`country-code-option ${country.code === value ? 'selected' : ''}`}
                            onClick={() => handleCountrySelect(country)}
                        >
                            <span className="country-flag">{country.flag}</span>
                            <span className="country-name">{country.name}</span>
                            <span className="country-code">{country.code}</span>
                        </div>
                    ))}
                </div>
            )}

            {error && <div className="invalid-feedback">{error}</div>}
        </div>
    )
}

export default CountryCodeSelector
